// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H0rP","toggle":"styles_toggle__3x6g1","preview":"styles_preview__3dCTo"};